<template>
  <v-autocomplete
    :items="filteredServices"
    :value="value"
    item-text="title"
    item-value="id"
    hide-no-data
    multiple
    :rules="rules"
    label="Services"
    @change="handleSelectChange">
    <template slot="selection" slot-scope="data">
      <v-chip
        close
        :color="data.item.backgroundColor"
        class="chip--select-multi v-chip--small"
        @input="removeService(data.item.id)">
        <v-tooltip bottom>
            <span slot="activator" v-bind:style="{'color': data.item.fontColor}">
              {{ data.item.code }}
            </span>
          {{ data.item.title }}
          <dev-mode>
            {{data.item.id}}
          </dev-mode>
        </v-tooltip>
      </v-chip>
    </template>
  </v-autocomplete>
</template>

<script>
    import _ from 'lodash'
    import DevMode from '../DevMode'
    import {mapActions, mapGetters} from 'vuex'

    export default {
        name: 'services-select',
        components: {
            DevMode
        },
        props: {
            value: {
                type: Array,
            },
            rules: {
                type: Array,
                default() {
                    return []
                }
            },
            excludeServices: {
                type: Array,
                default() {
                    return []
                }
            }
        },
        data() {
            return {}
        },
        computed: {
            ...mapGetters({
                availableServices: 'coloredAvailableServices'
            }),
            filteredServices() {
                return _.filter(this.availableServices, s => this.excludeServices.indexOf(s.id) < 0)
            }
        },
        mounted() {
            this.fetchInitDataIfRequired()
        },
        methods: {
            ...mapActions({
                fetchInitDataIfRequired: 'fetchInitDataIfRequired'
            }),
            handleSelectChange(newValue) {
                if (_.isEqual(this.value, newValue)) {
                    return
                }
                this.$emit('input', newValue)
            },
            removeService(serviceId) {
                const removeIndex = this.value.indexOf(serviceId);
                let newValue = _.filter(this.value, (item, index) => index !== removeIndex);
                this.$emit('input', newValue)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Ui/mcc/ServicesSelect.vue